import { render, staticRenderFns } from "./QuestionExerciseChapter.vue?vue&type=template&id=e9b0094a&"
import script from "./QuestionExerciseChapter.vue?vue&type=script&lang=js&"
export * from "./QuestionExerciseChapter.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExerciseChapter.vue?vue&type=style&index=0&id=e9b0094a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports